import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import { Icon } from "@mui/material";
import { unitGroups } from "../../utils/unit-measurements";

interface UnitSelectorProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
}

export const UnitSelector: React.FC<UnitSelectorProps> = ({
  value,
  onChange,
  error,
  helperText,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth error={error}>
      <InputLabel>Unit of Measurement</InputLabel>
      <Select
        value={value}
        label="Unit of Measurement"
        onChange={handleChange}
        error={error}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {unitGroups.map((group) => [
          <MenuItem key={group.name} disabled divider>
            <Typography variant="caption" color="text.secondary">
              {group.name}
            </Typography>
          </MenuItem>,
          ...group.units.map((unit) => (
            <MenuItem key={unit.value} value={unit.value}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Icon sx={{ mr: 1 }}>
                  {group.name === "Weight"
                    ? "scale"
                    : group.name === "Volume"
                    ? "water_drop"
                    : "inventory_2"}
                </Icon>
                {unit.label}
              </Box>
            </MenuItem>
          )),
        ])}
      </Select>
    </FormControl>
  );
};
